import { useState } from 'react';

import ChildrenImages from './image/ChildrenImages';
import ListImage from './image/ListImage';
import MainImage from './image/MainImage';

const Image = (props) => {
  const { product, imageDisplay, size, index, linkType } = props;

  const [imageIndex, setImageIndex] = useState(index);

  if (!product.images) {
    return null;
  }
  if (product.images.length === 0) {
    return null;
  }

  if (product.images.length < index + 1) {
    return null;
  }

  const onImageClick = (i) => {
    setImageIndex(i);
  };

  if (imageDisplay === 'List') {
    return (
      <ul>
        {product.images.map((image) => (
          <li key={image.id}>
            <ListImage
              linkType={linkType}
              image={image}
              size={size}
              product={product}
            />
          </li>
        ))}
      </ul>
    );
  }

  return (
    <>
      <MainImage
        linkType={linkType}
        image={product.images[imageIndex]}
        product={product}
        size={size}
      />
      {imageDisplay === 'All' && (
        <ChildrenImages product={product} onImageClick={onImageClick} />
      )}
    </>
  );
};

export default Image;
